













import './KisweSliderVolume.scss'
import { computed, defineComponent, toRef } from '@vue/composition-api'
import KisweSlider from '../KisweSlider/KisweSlider.vue'
import { dBFS } from '@/modules/audio/utils/volumeConversion'

const formatTooltip = (val: number) => {
  const tempLevel = dBFS(val, 1)
  let dbLevel: number|string = tempLevel >= 100 ? 0 : tempLevel
  if (dbLevel === 0) dbLevel = '-0'
  return `${ dbLevel } dB`
}

export default defineComponent({
  name: 'KisweSliderVolume',
  components: {
    KisweSlider
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    vertical: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    input (_value: number) { return true }
  },
  setup (props, { emit }) {
    const propValue = toRef(props, 'value')

    const val = computed({
      get (): number {
        return propValue.value
      },
      set (newVal: number) {
        emit('input', newVal)
      }
    })

    return {
      formatTooltip,
      val
    }
  }
})
